export const US_EAST_REGION = 'us-east-1';
// This is the default region in the c++ object store as well
export const DEFAULT_S3_REGION = US_EAST_REGION;
